import React from 'react';

import { Col, Row } from 'react-bootstrap';

import Container from 'components/shared/Container';
import MfrProductGmvReportCard from 'components/data_reports/MfrProductGmvReportCard';

function DataReportsView() {
  return (
    <Container>
      <div>
        <h3 className="font-weight-bold ml-3">Data Reports</h3>
      </div>
      <Row>
        <Col md={5}>
          <MfrProductGmvReportCard />
        </Col>
      </Row>
    </Container>
  );
}

export default DataReportsView;
